import React, { useState, useEffect } from 'react';
import { Collapse, Navbar, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link, useLocation } from 'react-router-dom'; // Use useLocation hook
import './NavMenu.css';
import halogo from './images/HA_logo.png';
import atal from './images/DigitFusion.png';
import RealTimeClock from "./RealTimeClock";
import click from './shortclick.mp3';

const NavMenu = () => {
    const [collapsed, setCollapsed] = useState(true);
    const location = useLocation(); // Get current location

    const toggleNavbar = () => {
        setCollapsed(!collapsed);
    }

    const playClickSound = () => {
        const audio = new Audio(click);
        audio.play();
    }

    // Function to check if a nav item is active
    const isActive = (path) => {
        return location.pathname === path;
    }

    return (
        <header>
            <Navbar className="menustyle">
                <img src={halogo} alt="halogo" width="40" />
                <img src={atal} alt="atal" width="60" style={{ marginLeft: "15px", marginRight: "15px" }} />
                <NavbarToggler onClick={toggleNavbar} className="mr-2" />
                <Collapse isOpen={!collapsed} navbar>
                    <ul className="navbar-nav flex-grow">
                        <NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/') ? 'active-nav' : ''}`}
                                to="/"
                            >
                                Home
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/map') ? 'active-nav' : ''}`}
                                to="/map"
                            >
                                富蝶邨
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/doors') ? 'active-nav' : ''}`}
                                to="/doors"
                            >
                                門口監察
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/leakage') ? 'active-nav' : ''}`}
                                to="/leakage"
                            >
                                漏水監察
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/rubbishbins') ? 'active-nav' : ''}`}
                                to="/rubbishbins"
                            >
                                回收箱監察
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/firepanels') ? 'active-nav' : ''}`}
                                to="/firepanels"
                            >
                                消防面板
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/meters') ? 'active-nav' : ''}`}
                                to="/meters"
                            >
                                智能報錶
                            </NavLink>
                        </NavItem>
                        {/*<NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/waterflowmeters') ? 'active-nav' : ''}`}
                                to="/waterflowmeters"
                            >
                                用水量監察
                            </NavLink>
                        </NavItem>*/}
                        <NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/panels') ? 'active-nav' : ''}`}
                                to="/panels"
                            >
                                控制面板
                            </NavLink>
                        </NavItem>
                        {/*<NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/powermeterpanels') ? 'active-nav' : ''}`}
                                to="/powermeterpanels"
                            >
                                升降機用電
                            </NavLink>
                        </NavItem>*/}
                        {/*<NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/switchwl') ? 'active-nav' : ''}`}
                                to="/switchwl"
                            >
                                制櫃頂水濕
                            </NavLink>
                        </NavItem>*/}
                        <NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/environments') ? 'active-nav' : ''}`}
                                to="/environments"
                            >
                                溫度濕度
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/busbars') ? 'active-nav' : ''}`}
                                to="/busbars"
                            >
                                BusBars
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/fallsensors') ? 'active-nav' : ''}`}
                                to="/fallsensors"
                            >
                                跌倒監察
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/tenantmeters') ? 'active-nav' : ''}`}
                                to="/tenantmeters"
                            >
                                住戶監察
                            </NavLink>
                        </NavItem>
                        {/*
                        <NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/dailychart') ? 'active-nav' : ''}`}
                                to="/dailychart"
                            >
                                每日圖表
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/weeklychart') ? 'active-nav' : ''}`}
                                to="/weeklychart"
                            >
                                每週圖表
                            </NavLink>
                        </NavItem>   */}
                        <NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/energy') ? 'active-nav' : ''}`}
                                to="/energy"
                            >
                                能源效益
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                tag={Link}
                                onClick={playClickSound}
                                className={`text-dark ${isActive('/notification') ? 'active-nav' : ''}`}
                                to="/notification"
                            >
                                EventLog
                            </NavLink>
                        </NavItem>
                    </ul>
                </Collapse>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <RealTimeClock />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Navbar>
        </header>
    );
}

export default NavMenu;